export const BOOKING_RETRY_LIMIT = 2;

export const BOOKED_CONFETTI_MS = 12000;
